var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBowling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bowling",
    clipPath: "url(#clip0_23_1733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3038 2.16958C10.2474 0.113111 6.901 0.113111 4.84453 2.16958C3.68741 3.32667 3.34224 4.51014 3.0083 5.65436C2.64462 6.90001 2.13397 8.32291 0.692754 9.76413C0.534167 9.92271 0.534167 10.1794 0.692754 10.3379C0.851341 10.4965 1.10798 10.4965 1.26654 10.3379C1.68069 9.92377 1.99597 9.77013 2.32285 9.65217C2.04841 10.1556 1.89332 10.6171 1.74225 11.0703C1.46264 11.9091 1.19873 12.7009 0.11894 13.7807C-0.0396468 13.9392 -0.0396468 14.1959 0.11894 14.3544C0.277528 14.513 0.534167 14.513 0.692727 14.3544C1.77252 13.2747 2.56429 13.0107 3.4031 12.7311C3.85625 12.5801 4.31773 12.4249 4.82122 12.1505C4.70331 12.4774 4.54962 12.7927 4.13545 13.2069C3.97686 13.3655 3.97686 13.6221 4.13545 13.7807C4.29403 13.9392 4.55067 13.9392 4.70923 13.7807C6.15045 12.3394 7.57335 11.8288 8.819 11.4651C9.96322 11.1311 11.1467 10.786 12.3038 9.62888C14.3603 7.57242 14.3603 4.22605 12.3038 2.16958Z",
    fill: "url(#paint0_linear_23_1733)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.1563 3.31715C9.7325 1.89333 7.41604 1.89333 5.99219 3.31715C4.56834 4.74097 4.56837 7.05743 5.99219 8.48128C7.41602 9.90513 9.73248 9.9051 11.1563 8.48128C12.5802 7.05746 12.5801 4.74097 11.1563 3.31715ZM8.57425 4.75163C8.41582 4.5932 8.41582 4.33627 8.57425 4.17784C8.73273 4.01936 8.98961 4.01942 9.14803 4.17784C9.30646 4.33627 9.30651 4.59315 9.14803 4.75163C8.98961 4.91005 8.7327 4.91005 8.57425 4.75163ZM8.28737 6.18611C8.12894 6.02768 8.12894 5.77075 8.28737 5.61232C8.44585 5.45384 8.70273 5.4539 8.86115 5.61232C9.01958 5.77075 9.01963 6.02763 8.86115 6.18611C8.7027 6.34453 8.44579 6.34453 8.28737 6.18611ZM9.72185 5.8992C9.56342 5.74078 9.56342 5.48384 9.72185 5.32542C9.88033 5.16694 10.1372 5.16699 10.2956 5.32542C10.4541 5.48384 10.4541 5.74072 10.2956 5.8992C10.1372 6.05765 9.88027 6.05765 9.72185 5.8992Z",
    fill: "url(#paint1_linear_23_1733)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_1733",
    x1: 0.120084,
    y1: 14.352,
    x2: 12.3031,
    y2: 2.16895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_1733",
    x1: 5.99242,
    y1: 8.47971,
    x2: 11.1558,
    y2: 3.31636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFD5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_1733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8462,
    height: 13.8462,
    fill: "white",
    transform: "translate(0 0.627228)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowling);
export default __webpack_public_path__ + "static/media/Bowling.cc058f2e40826c8d668dba87087c9aed.svg";
export { ForwardRef as ReactComponent };